var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76367 9.72742H12.7819",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.72742H3.40003",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76408 9.72738C7.76408 10.1589 7.63612 10.5807 7.39638 10.9395C7.15663 11.2984 6.81588 11.578 6.41719 11.7431C6.01851 11.9083 5.57982 11.9515 5.15658 11.8673C4.73334 11.7831 4.34458 11.5753 4.03944 11.2702C3.7343 10.965 3.5265 10.5763 3.44232 10.153C3.35813 9.7298 3.40134 9.2911 3.56647 8.89242C3.73161 8.49374 4.01127 8.15298 4.37007 7.91324C4.72887 7.6735 5.15071 7.54553 5.58224 7.54553C6.1609 7.54553 6.71586 7.7754 7.12504 8.18458C7.53421 8.59376 7.76408 9.14872 7.76408 9.72738V9.72738Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63646 3.18176H1",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 3.18185C12.9999 2.75032 12.872 2.32848 12.6322 1.96968C12.3925 1.61088 12.0517 1.33122 11.653 1.16608C11.2544 1.00095 10.8157 0.957738 10.3924 1.04192C9.96918 1.12611 9.58042 1.33391 9.27528 1.63905C8.97014 1.94419 8.76234 2.33295 8.67816 2.75619C8.59397 3.17943 8.63718 3.61812 8.80231 4.0168C8.96745 4.41549 9.24711 4.75624 9.60591 4.99599C9.96471 5.23573 10.3866 5.36369 10.8181 5.36369C11.3967 5.36369 11.9517 5.13382 12.3609 4.72465C12.7701 4.31547 12.9999 3.76051 12.9999 3.18185Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.276370f0.svg";
export { ForwardRef as ReactComponent };